import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { ToggleHide, ToggleShow } from '../actions/loader.actions';

export interface LoaderStateModel {
    loaderCount: number;
    isLoading: boolean;
}

@State<LoaderStateModel>({
    name: 'loader',
    defaults: {
        loaderCount: 0,
        isLoading: false,
    },
})
@Injectable()
export class LoaderState {
    @Selector()
    public static isLoading(state: LoaderStateModel): boolean {
        return state.isLoading;
    }

    @Action(ToggleShow)
    public toggleShow(ctx: StateContext<LoaderStateModel>): void {
        const state: LoaderStateModel = ctx.getState();

        ctx.patchState({
            isLoading: true,
            loaderCount: state.loaderCount + 1,
        });
    }

    @Action(ToggleHide)
    public toggleHide(ctx: StateContext<LoaderStateModel>): void {
        const state: LoaderStateModel = ctx.getState();

        const loaderCount: number = state.loaderCount - 1 > 0 ? state.loaderCount - 1 : 0;

        ctx.patchState({
            isLoading: loaderCount > 0,
            loaderCount,
        });
    }
}
